// extracted by mini-css-extract-plugin
export default {"quantity-picker":"MjKRc","quantityPicker":"MjKRc","button":"IxXTx","counter":"QHTQA","disabled":"o-jHl"};